export default __webpack_public_path__ + "static/media/MobiKwik.74b48516.svg";